import React from 'react';
import PropTypes from 'prop-types';
import BaseFlag from 'country-flag-icons/react/3x2';
import countryCodes from './countries.json';
import { FlagWrapper } from './styled';

export const Flag = ({
  country,
  className,
  showCountryName = true,
  defaultValue = '-'
}) => {
  const countryInfo = country
    ? countryCodes.find(
        (item) => item.name === country || item.code === country
      )
    : defaultValue;

  if (!countryInfo) return defaultValue;

  const FlagComponent = BaseFlag[countryInfo.code];

  if (!FlagComponent) return '';

  return (
    <FlagWrapper className={className}>
      <FlagComponent title={country} />
      {showCountryName && (
        <div className="country-name">{countryInfo.name}</div>
      )}
    </FlagWrapper>
  );
};

Flag.propTypes = {
  country: PropTypes.string,
  className: PropTypes.string,
  showCountryName: PropTypes.bool,
  defaultValue: PropTypes.string
};
